import { directSalesFlowPages, DirectSalesFlowSlug } from "../constants";
import { useFlowNavigation } from "../../hooks/useFlowNavigation";

export function useDirectSalesSignupFlowNavigation(slug: DirectSalesFlowSlug) {
  return useFlowNavigation(slug, directSalesFlowPages);
}
